module.exports = __webpack_public_path__ + "img/emv_en-BE.af7c4506.svg";